// import Accessories from '../../assets/applestore/Accessories.png';
// import AirTag from '../../assets/applestore/AirTag.png';
// import AppleTV from '../../assets/applestore/AppleTV.png';
import Applewatch from '../../assets/apple/iPhoneIcones/iWatchIcon.png';
import Ipad from '../../assets/apple/iPhoneIcones/iPadIcon.png';
import earbuds from '../../assets/apple/iPhoneIcones/airpodIcon.png';
import mac from '../../assets/apple/iPhoneIcones/macIcon.png';
import iphone from '../../assets/apple/iPhoneIcones/iPhonesIcon.png';

import './AppleStore.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

import AppleProductList from './AppleProductList';
import AppleNewArrivals from './AppleNewArrivals';
// import AppleExplore from './AppleExplore';
// import AppleBanner from './AppleBanner';
import IPhone17Carousel from './PhoneCarousel/iPhone17Carousel';
import IPhoneAirCarousel from './PhoneCarousel/IPhoneAirCarousel';
import WatchSE3Carousel from './PhoneCarousel/WatchSE3Carousel';
import IpadCarousel from './IpadCarousel/IpadCarousel';
import MacCarousel from './MacCarousel/MacCarousel';

export const AppleCategories = [
  {
    id: 2,
    name: 'I Phone',
    path: '/applestore/products-list',
    image: iphone,
    type: 'iphone',
  },
  {
    id: 3,
    name: 'I Pad',
    path: '/applestore/products-list',
    image: Ipad,
    type: 'ipad',
  },
  {
    id: 4,
    name: 'Apple Watch',
    path: '/applestore/products-list',
    image: Applewatch,
    type: 'applewatch',
  },
  {
    id: 6,
    name: 'Air Pods',
    path: '/applestore/products-list',
    image: earbuds,
    type: 'airpods',
  },
  {
    id: 1,
    name: 'Mac',
    path: '/applestore/products-list',
    image: mac,
    type: 'mac',
  },

  // { id: 5, name: 'Vision Pro', path: '', image: Vision },

  // { id: 7, name: 'Air Tags', path: '', image: AirTag },
  // { id: 8, name: 'Apple TV', path: '', image: AppleTV },
  // { id: 9, name: 'Home Pod', path: '', image: Speakers },
  // { id: 10, name: 'Accessories', path: '', image: Accessories },
];
export const AppleNewArrivalList = [
  {
    id: 1,
    name: 'Mac',
    image: mac,
    path: '/applestore/iphone-products-list/iphone-detail-page/mac/1',
  },
  {
    id: 2,
    name: 'I Phone',
    image: iphone,
    path: '/applestore/iphone-products-list/iphone-detail-page/iphone/1',
  },
  {
    id: 3,
    name: 'I Pad',
    image: Ipad,
    path: '/applestore/iphone-products-list/iphone-detail-page/ipad/1',
  },
  {
    id: 4,
    name: 'Apple Watch',
    image: Applewatch,
    path: '/applestore/iphone-products-list/iphone-detail-page/applewatch/1',
  },
];
function AppleStore() {
  return (
    <>
      <Nav theme="light" />
      <div className="apple-store" style={{ overflowX: 'hidden' }}>
        <section id="apple-products-list" className="mt-5">
          <AppleProductList />
        </section>
        <section id="apple-banner" className="mt-5">
          <IPhone17Carousel />
        </section>
        <section id="apple-banner" className="mt-5">
          <IPhoneAirCarousel />
        </section>
        <section id="apple-banner" className="mt-5">
          <WatchSE3Carousel />
        </section>
        <section id="apple-banner" className="mt-5">
          <IpadCarousel />
        </section>
        <section id="apple-banner" className="mt-5">
          <MacCarousel />
        </section>
        <section id="apple-new-arrivals" className="mt-5">
          <AppleNewArrivals />
        </section>
        {/* <section id="apple-explore" className="mt-5">
          <AppleExplore />
        </section> */}
      </div>
      <Footer />
    </>
  );
}

export default AppleStore;
